// src/api/auth.api.js
import axiosInstance from './axiosInstance';

/**
 * تسجيل الدخول — يرجع { access, refresh }
 */
export const loginRequest = (username, password) =>
  axiosInstance.post('/token/', { username, password });

/**
 * جلب بيانات المستخدم الحالي
 */
export const fetchCurrentUser = () =>
  axiosInstance.get('/me/');